import type { Environment } from "./config.types"

const devUrlRegex = /^https?:\/\/dev\./
const localUrlRegex = /^https?:\/\/localhost/

export const getEnvironment = (url: string): Environment => {
  if (localUrlRegex.test(url)) {
    return "local"
  }
  if (devUrlRegex.test(url)) {
    return "development"
  }
  return "production"
}
